import { useTranslations } from "next-intl";

import Button from "~/components/common/button";
import EVAErrors from "~/components/form/eva-errors";

import Dialog from "../../common/dialog";
import Icon from "../../common/icon";
import deleteWishlistDialogStyles from "./delete-wishlist-dialog.module.scss";
import styles from "./wishlist.module.scss";

type Props = {
  isOpen?: boolean;
  onClose: () => void;
  cleanError?: () => void;
  onAfterClose?: () => void;
  onSubmit: (confirm: boolean) => void;
  error?: any;
};

export default function DeleteWishlistDialog(props: Props) {
  const t = useTranslations();

  return (
    <Dialog
      isOpen={props.isOpen}
      title={
        <>
          <Icon name="bin" />
          <span>{t("generic.myaccount.wishlist.delete_wishlist_title")}</span>
        </>
      }
      onClose={props.onClose}
      onAfterOpen={props.cleanError}
      onAfterClose={props.onAfterClose}
      customStyles={deleteWishlistDialogStyles}
    >
      <p>{t("generic.myaccount.wishlist.delete_wishlist_description")}</p>
      <EVAErrors error={props.error} />
      <Button variant="primary" type="button" onClick={() => props.onSubmit(true)}>
        {t("generic.myaccount.wishlist.delete_wishlist_confirm_cta")}
      </Button>
      <Button variant="secondary" type="button" onClick={() => props.onSubmit(false)}>
        {t("generic.myaccount.wishlist.delete_wishlist_cancel_cta")}
      </Button>
    </Dialog>
  );
}
